<template>
  <app-page-container :custom="1600" :min-height="0">
    <app-page-header design="new" title="Client refunds" compact />
    <AppTabs design="new" refined weight="medium" :tabs="tabs" />
    <router-view />
  </app-page-container>
</template>
<script>
import AppTabs from '@/components/AppTabs'
export default {
  name: 'FinanceRefundsLayout',
  components: { AppTabs },
  data() {
    return { tabs: [
      { name: 'finance-refunds', label: 'Awaiting payment' },
      { name: 'finance-refunds-completed', label: 'Completed' },
      { name: 'finance-refunds-all', label: 'All requests' }
    ] }
  }
}
</script>
